var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubheaderSecurityCam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 32.1436L36.5 29.6436",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5023 36.4098C37.3482 36.0991 36.5899 34.7675 36.2385 33.5555C36.0759 32.9951 35.5184 32.6314 34.9554 32.7849L31.3837 33.759C30.8836 33.8954 30.5674 34.392 30.671 34.8999C31.0715 36.8643 31.6603 38.5777 33.5 40C35.6271 41.6445 38.0977 42.0135 39.6248 42.0036C40.1269 42.0004 40.5 41.5737 40.5 41.0714V37.4772C40.5 36.9249 40.0489 36.4887 39.5023 36.4098Z",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4388 23.3132L39.1696 26.0406L13.0896 33.0287L11.019 25.3013",
    stroke: "#4F7FA7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.7646L37.4778 12.0001L40.3248 22.6253L21.0063 27.8016C15.6716 29.2311 10.1882 26.0652 8.75882 20.7306L8.5 19.7646Z",
    stroke: "#4F7FA7",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 34,
    width: 4,
    height: 11,
    rx: 1,
    fill: "#4F7FA7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubheaderSecurityCam);
export default __webpack_public_path__ + "static/media/subheader-security-cam.c9228e177d89482d971f9a69c436b724.svg";
export { ForwardRef as ReactComponent };